import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-blue-dark py-20 pb-8 text-white max-lg:pt-8',
    container:
      'container grid grid-cols-[1fr_240px] gap-12 max-lg:flex max-lg:max-w-[500px] max-lg:flex-col max-lg:gap-1 lg:px-14',

    naosBlock:
      'col-start-1 flex w-full max-w-[900px] items-center gap-12 max-lg:mb-5 max-lg:flex-col max-lg:gap-2 max-lg:text-center',
    naosLogo: 'flex-none',
    naosDescription:
      'font-rf-tone text-base leading-normal font-light opacity-50 max-lg:px-5 max-lg:text-xs lg:whitespace-pre-line',

    brandsSection:
      'col-start-1 flex w-full max-w-[842px] gap-[60px] pt-2 max-lg:flex-wrap max-lg:gap-1',
    brandBlock: 'flex w-1/3 flex-col gap-6 max-lg:w-full max-lg:gap-0',
    brandLogo: 'h-[36px] w-auto',
    brandLogoLink: 'pointer-events-none lg:pointer-events-auto',
    brandLinks: 'flex w-full flex-col gap-4 max-lg:bg-[#062F40] max-lg:p-5',
    brandLinksGroup: 'flex w-full flex-col gap-3',
    brandLink: 'font-rf-tone link text-base leading-normal font-light',

    socialBlock: 'group flex w-full items-center gap-2',
    socialIcon:
      'link-invert flex h-6 w-auto items-center justify-start group-hover:opacity-100 lg:justify-center',
    socialText:
      'font-rf-tone text-base leading-normal font-light opacity-50 transition-opacity group-hover:opacity-100',

    bottomSection: 'flex w-full flex-col justify-between gap-4 max-lg:gap-0',
    bottomTitle: 'font-rf-tone text-lg leading-[1.4] font-semibold',
    bottomLinks:
      'flex max-w-[842px] gap-2.5 max-lg:flex-wrap max-lg:bg-[#062F40] max-lg:p-5',
    bottomLinksColumn: 'flex w-1/3 flex-col gap-2.5 max-lg:w-full',
    bottomLink: 'font-rf-tone link text-base leading-normal font-light',

    sideColumn:
      'col-start-2 row-start-1 row-end-4 flex w-[240px] flex-col gap-[48px] max-lg:mt-[48px]',
    contactSection:
      'flex flex-col justify-between gap-[60px] max-lg:gap-[48px]',
    contactWrapper: 'flex flex-col gap-5',
    phoneBlock: 'flex w-[190px] flex-col gap-1',
    phoneNumber: 'font-rf-tone text-2xl leading-[1.2] font-semibold',
    phoneHours: 'font-rf-tone text-base leading-normal font-light opacity-50',
    email: 'font-rf-tone link text-lg leading-[1.4] font-semibold',

    podcastBlock: 'flex w-full flex-col gap-6',
    podcastHeader: 'flex w-full items-center gap-4',
    podcastIcon:
      'bg-blue flex h-10 w-10 items-center justify-center rounded-full',
    podcastTitle:
      'font-rf-tone text-lg leading-[1.4] font-semibold whitespace-pre-line',
    socialLinks: 'flex items-center gap-6',

    appSection: 'flex w-full flex-col gap-6',
    appTitleWrapper: 'flex w-full flex-col gap-4',
    appLinks: 'flex items-center gap-10',
    appButton: 'link-invert flex items-center gap-2',

    copyright:
      'col-span-full flex w-full justify-between gap-3 opacity-50 max-lg:mt-[48px] max-sm:flex-col max-sm:flex-wrap',
    copyrightBlock: 'flex flex-col gap-1',
    copyrightText: 'font-rf-tone text-base leading-normal font-light',
    recommendationLink: 'link underline'
  }
});
